
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import tippy, { Instance } from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light.css'; // light theme
import 'tippy.js/animations/scale.css'; // animation scale

@Component({
  components: {}
})
export default class TippyPopover extends Vue {
  @Prop({ default: 'Open Popover' }) private anchorAriaLabel!: string;
  @Prop({ default: '' }) private anchorButtonClass!: string;
  @Prop({ default: false }) private popoverOpen!: boolean;
  @Prop({ default: false }) private overflowOverride!: boolean;
  @Prop({ required: false, default: false }) private disabled!: boolean;
  @Prop({ required: false, type: Boolean }) private hideOnClick?: boolean;

  private isPopoverOpen = false;

  private tippyInstance!: Instance;

  private async mounted() {
    // // may need to add a prop to make this wait for the next tick.
    // // Wait till after vue-simple-portal finishes the move
    // // https://github.com/LinusBorg/vue-simple-portal/issues/14#issuecomment-511355871
    // await this.$nextTick();

    const template = this.$refs.content as HTMLElement;
    const trigger = this.$refs.tippyTrigger as Element;

    if (template) {
      template.style.display = 'block';
      this.tippyInstance = await tippy(trigger, {
        content: template,
        interactive: true,
        allowHTML: true,
        animation: 'scale',
        inertia: true,
        duration: 500,
        trigger: 'manual',
        hideOnClick: 'toggle',
        placement: 'auto-start',
        maxWidth: 500,
        theme: 'light',
        onClickOutside: () => {
          if (this.hideOnClick) {
            this.isPopoverOpen = false;
          }
        },
        onShow: () => {
          this.$emit('open');
        },
        onHide: () => {
          this.$emit('close');
        }
      });
    }

    // load from prop
    this.isPopoverOpen = this.popoverOpen;
  }

  @Watch('isPopoverOpen', { immediate: true })
  private popoverOpenChanged(val: boolean) {
    if (!this.tippyInstance) return;
    if (val) {
      this.tippyInstance.show();
    } else {
      this.tippyInstance.hide();
    }
  }

  @Watch('popoverOpen')
  private popoverPropOpenChanged(val: boolean) {
    this.isPopoverOpen = val;
  }
}
